// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Character creator styled as an HfSandbox editor surface. */
.character-modal-overlay {
  padding: 16px;
  background: rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
}

.character-modal {
  --character-primary-bg: #17191d;
  --character-primary-bg-hover: #292c32;
  --character-primary-border: #17191d;
  --character-primary-text: #ffffff;
  display: flex;
  width: min(860px, 100%);
  max-width: none;
  max-height: min(720px, calc(100vh - 32px));
  padding: 0;
  flex-direction: column;
  overflow: hidden;
  color: var(--color-text-primary);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.24);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.character-modal-header {
  display: flex;
  min-height: 56px;
  padding: 10px 12px;
  box-sizing: border-box;
  align-items: center;
  gap: 10px;
  background: var(--color-bg-sidebar);
  border-bottom: 1px solid var(--color-border-input);
  flex-shrink: 0;
}

.character-modal-heading-copy {
  min-width: 0;
  flex: 1 1;
}

.character-modal-title {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.character-modal-heading-copy p {
  margin: 3px 0 0;
  color: var(--color-text-secondary);
  font-size: 9px;
  line-height: 1.35;
}

.character-modal-close {
  display: grid;
  width: 28px;
  height: 28px;
  padding: 0;
  place-items: center;
  color: var(--color-text-secondary);
  background: transparent;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease;
}

.character-modal-close:hover:not(:disabled) {
  color: var(--color-text-primary);
  background: var(--color-bg-user-bubble);
}

.character-modal-close:disabled {
  opacity: 0.4;
  cursor: default;
}

.character-modal-form {
  display: flex;
  min-height: 0;
  flex: 1 1;
  flex-direction: column;
}

.character-modal-body {
  display: grid;
  min-height: 0;
  flex: 1 1;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  overflow-y: auto;
  background: var(--color-bg-canvas-surface);
}

.character-form-panel {
  display: flex;
  min-width: 0;
  padding: 18px;
  flex-direction: column;
  gap: 14px;
  background: var(--color-bg-canvas-frame);
}

.character-form-panel--voice {
  background: var(--color-bg-canvas-surface);
  border-left: 1px solid var(--color-border-input);
}

.character-form-panel-heading {
  display: flex;
  align-items: flex-start;
  gap: 7px;
}

.character-form-step {
  padding-top: 2px;
  color: var(--color-text-secondary);
  font: 600 8px/1.2 ui-monospace, SFMono-Regular, Menlo, monospace;
}

.character-form-step::after {
  content: ' /';
}

.character-form-panel-heading h3 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
}

.character-form-panel-heading p {
  margin: 2px 0 0;
  color: var(--color-text-secondary);
  font-size: 9px;
  line-height: 1.35;
}

.character-modal-label {
  display: flex;
  min-width: 0;
  margin: 0;
  flex-direction: column;
  gap: 5px;
}

.character-modal-label--grow {
  flex: 1 1;
}

.character-modal-label > span,
.character-field-label {
  color: var(--color-text-primary);
  font-size: 9.5px;
  font-weight: 600;
  line-height: 1.3;
}

.character-modal-label > span em {
  margin-left: 5px;
  color: var(--color-text-secondary);
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
}

.character-modal-label > small {
  color: var(--color-text-secondary);
  font-size: 8px;
  line-height: 1.35;
}

.character-modal-input,
.character-modal-textarea {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  color: var(--color-text-primary);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  outline: none;
  font: 400 11px/1.5 'Geist Sans', system-ui, sans-serif;
  transition: border-color 0.15s ease;
}

.character-modal-input {
  height: 32px;
}

.character-modal-input:focus,
.character-modal-textarea:focus {
  border-color: var(--color-text-secondary);
}

.character-modal-input::placeholder,
.character-modal-textarea::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.72;
}

.character-modal-textarea {
  min-height: 82px;
  resize: vertical;
}

.character-modal-textarea--appearance {
  min-height: 210px;
  flex: 1 1;
}

.character-modal-textarea--script {
  min-height: 66px;
}

.character-voice-source {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.character-voice-source-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.character-voice-source-options > button {
  display: flex;
  min-width: 0;
  min-height: 42px;
  padding: 7px 8px;
  align-items: center;
  color: var(--color-text-secondary);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.character-voice-source-options > button:hover {
  color: var(--color-text-primary);
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
}

.character-voice-source-options > button.active {
  color: var(--character-primary-text);
  background: var(--character-primary-bg);
  border-color: var(--character-primary-border);
}

.character-voice-source-options > button > span {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
}

.character-voice-source-options strong,
.character-voice-source-options small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.character-voice-source-options strong {
  color: var(--color-text-primary);
  font-size: 9.5px;
  font-weight: 600;
}

.character-voice-source-options small {
  color: var(--color-text-secondary);
  font-size: 7.5px;
  font-weight: 500;
}

.character-voice-source-options > button.active strong {
  color: var(--character-primary-text);
}

.character-voice-source-options > button.active small {
  color: rgba(255, 255, 255, 0.68);
}

.character-voice-upload {
  display: flex;
  width: 100%;
  min-height: 68px;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  gap: 8px;
  color: var(--color-text-secondary);
  background: var(--color-bg-input);
  border: 1px dashed var(--color-border-input);
  border-radius: 4px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.character-voice-upload:hover,
.character-voice-upload.dragging {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
}

.character-voice-upload.has-file {
  border-style: solid;
}

.character-voice-upload-icon {
  color: var(--color-text-secondary);
  flex: 0 0 auto;
}

.character-voice-upload-copy {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 3px;
}

.character-voice-upload-copy strong,
.character-voice-upload-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.character-voice-upload-copy strong {
  color: var(--color-text-primary);
  font-size: 9.5px;
  font-weight: 600;
}

.character-voice-upload-copy small {
  color: var(--color-text-secondary);
  font-size: 8px;
}

.character-voice-upload-status {
  flex: 0 0 auto;
  color: var(--color-text-secondary);
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.character-voice-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.character-voice-preview {
  display: flex;
  min-height: 58px;
  padding: 9px 10px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
}

.character-voice-preview.ready {
  display: block;
}

.character-voice-preview-empty {
  display: flex;
  min-width: 0;
  align-items: center;
}

.character-voice-preview-empty > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.character-voice-preview-empty strong {
  color: var(--color-text-primary);
  font-size: 9.5px;
  font-weight: 600;
}

.character-voice-preview-empty small {
  overflow: hidden;
  color: var(--color-text-secondary);
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.character-voice-generate {
  display: inline-flex;
  min-height: 30px;
  padding: 6px 10px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: var(--character-primary-text);
  background: var(--character-primary-bg);
  border: 1px solid var(--character-primary-border);
  border-radius: 4px;
  font: 600 9px/1.2 inherit;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.character-voice-generate:hover:not(:disabled) {
  background: var(--character-primary-bg-hover);
}

.character-voice-generate:disabled {
  opacity: 0.4;
  cursor: default;
}

.character-voice-preview-heading {
  display: flex;
  margin-bottom: 8px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.character-voice-preview-heading > span {
  color: var(--color-text-secondary);
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.character-voice-preview-heading > button {
  display: inline-flex;
  padding: 2px 0;
  align-items: center;
  gap: 4px;
  color: var(--color-text-secondary);
  background: transparent;
  border: 0;
  font: 600 8px/1.2 inherit;
  cursor: pointer;
}

.character-voice-preview-heading > button:hover:not(:disabled) {
  color: var(--color-text-primary);
}

.character-voice-player {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.character-voice-player-toggle {
  display: grid;
  width: 28px;
  height: 28px;
  padding: 0;
  place-items: center;
  color: var(--character-primary-text);
  background: var(--character-primary-bg);
  border: 1px solid var(--character-primary-border);
  border-radius: 50%;
  cursor: pointer;
  flex: 0 0 auto;
}

.character-voice-player-toggle:hover {
  background: var(--character-primary-bg-hover);
}

.character-voice-player-toggle svg:not(.lucide-pause) {
  margin-left: 1px;
}

.character-voice-player-progress {
  height: 3px;
  min-width: 60px;
  margin: 0;
  padding: 0;
  accent-color: var(--color-text-primary);
  cursor: pointer;
  flex: 1 1;
}

.character-voice-player-time {
  color: var(--color-text-secondary);
  font: 500 8px/1 ui-monospace, SFMono-Regular, Menlo, monospace;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.character-modal-footer {
  display: flex;
  min-height: 54px;
  padding: 9px 10px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  background: var(--color-bg-sidebar);
  border-top: 1px solid var(--color-border-input);
  flex-shrink: 0;
}

.character-modal-feedback {
  min-width: 0;
  color: var(--color-text-secondary);
  font-size: 8.5px;
  line-height: 1.35;
}

.character-modal-error {
  display: inline;
  margin: 0;
  padding: 0;
  color: var(--color-status-error-text, #dc2626);
  background: transparent;
  font-size: 9px;
  font-weight: 500;
}

.character-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}

.character-modal-cancel,
.character-modal-submit {
  display: inline-flex;
  min-height: 32px;
  padding: 7px 12px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 4px;
  font: 500 10px/1.2 inherit;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.character-modal-cancel {
  color: var(--color-text-primary);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
}

.character-modal-cancel:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.character-modal-submit {
  color: var(--character-primary-text);
  background: var(--character-primary-bg);
  border: 1px solid var(--character-primary-border);
}

.character-modal-submit:hover:not(:disabled) {
  background: var(--character-primary-bg-hover);
}

.character-modal-cancel:disabled,
.character-modal-submit:disabled {
  opacity: 0.4;
  cursor: default;
}

.character-modal-submit kbd {
  margin-left: 2px;
  padding: 2px 4px;
  color: rgba(255, 255, 255, 0.72);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 3px;
  font: 500 8px/1 ui-monospace, SFMono-Regular, Menlo, monospace;
}

.character-modal-close:focus-visible,
.character-voice-source-options > button:focus-visible,
.character-voice-upload:focus-visible,
.character-voice-generate:focus-visible,
.character-voice-player-toggle:focus-visible,
.character-modal-cancel:focus-visible,
.character-modal-submit:focus-visible {
  outline: 2px solid var(--color-text-secondary);
  outline-offset: 1px;
}

.character-spin {
  animation: characterSpin 0.85s linear infinite;
}

@keyframes characterSpin {
  to { transform: rotate(360deg); }
}

@media (max-width: 800px) {
  .character-modal-overlay {
    align-items: flex-end;
    padding: 12px;
  }

  .character-modal {
    max-height: calc(100vh - 24px);
  }

  .character-modal-body {
    display: block;
  }

  .character-form-panel {
    padding: 16px;
  }

  .character-form-panel--voice {
    border-top: 1px solid var(--color-border-input);
    border-left: 0;
  }

  .character-modal-textarea--appearance {
    min-height: 112px;
  }
}

@media (max-width: 540px) {
  .character-modal-overlay {
    padding: 0;
  }

  .character-modal {
    width: 100%;
    height: 100%;
    max-height: none;
    border: 0;
    border-radius: 0;
  }

  .character-modal-heading-copy p,
  .character-modal-feedback,
  .character-modal-submit kbd {
    display: none;
  }

  .character-voice-source-options {
    grid-template-columns: 1fr;
  }

  .character-modal-footer {
    justify-content: flex-end;
  }

  .character-modal-submit {
    flex: 1 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .character-spin {
    animation-duration: 1.5s;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CharacterCreateModal.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mCAAmC;EACnC,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAO;EACP,gDAAgD;EAChD,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gEAAgE;AAClE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sDAAsD;EACtD,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,iCAAiC;EACjC,4CAA4C;EAC5C,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oCAAoC;EACpC,uCAAuC;EACvC,iDAAiD;EACjD,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,uCAAuC;EACvC,eAAe;EACf,SAAO;AACT;;AAEA;EACE,kCAAkC;EAClC,8DAA8D;EAC9D,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mCAAmC;EACnC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,8CAA8C;EAC9C,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;;;;;;;EAOE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+CAA+C;IAC/C,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Character creator styled as an HfSandbox editor surface. */\n.character-modal-overlay {\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.4);\n  box-sizing: border-box;\n}\n\n.character-modal {\n  --character-primary-bg: #17191d;\n  --character-primary-bg-hover: #292c32;\n  --character-primary-border: #17191d;\n  --character-primary-text: #ffffff;\n  display: flex;\n  width: min(860px, 100%);\n  max-width: none;\n  max-height: min(720px, calc(100vh - 32px));\n  padding: 0;\n  flex-direction: column;\n  overflow: hidden;\n  color: var(--color-text-primary);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.24);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, -apple-system, sans-serif;\n}\n\n.character-modal-header {\n  display: flex;\n  min-height: 56px;\n  padding: 10px 12px;\n  box-sizing: border-box;\n  align-items: center;\n  gap: 10px;\n  background: var(--color-bg-sidebar);\n  border-bottom: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n}\n\n.character-modal-heading-copy {\n  min-width: 0;\n  flex: 1;\n}\n\n.character-modal-title {\n  margin: 0;\n  color: var(--color-text-primary);\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n}\n\n.character-modal-heading-copy p {\n  margin: 3px 0 0;\n  color: var(--color-text-secondary);\n  font-size: 9px;\n  line-height: 1.35;\n}\n\n.character-modal-close {\n  display: grid;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  place-items: center;\n  color: var(--color-text-secondary);\n  background: transparent;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: color 0.15s ease, background 0.15s ease;\n}\n\n.character-modal-close:hover:not(:disabled) {\n  color: var(--color-text-primary);\n  background: var(--color-bg-user-bubble);\n}\n\n.character-modal-close:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.character-modal-form {\n  display: flex;\n  min-height: 0;\n  flex: 1;\n  flex-direction: column;\n}\n\n.character-modal-body {\n  display: grid;\n  min-height: 0;\n  flex: 1;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  overflow-y: auto;\n  background: var(--color-bg-canvas-surface);\n}\n\n.character-form-panel {\n  display: flex;\n  min-width: 0;\n  padding: 18px;\n  flex-direction: column;\n  gap: 14px;\n  background: var(--color-bg-canvas-frame);\n}\n\n.character-form-panel--voice {\n  background: var(--color-bg-canvas-surface);\n  border-left: 1px solid var(--color-border-input);\n}\n\n.character-form-panel-heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n}\n\n.character-form-step {\n  padding-top: 2px;\n  color: var(--color-text-secondary);\n  font: 600 8px/1.2 ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.character-form-step::after {\n  content: ' /';\n}\n\n.character-form-panel-heading h3 {\n  margin: 0;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.character-form-panel-heading p {\n  margin: 2px 0 0;\n  color: var(--color-text-secondary);\n  font-size: 9px;\n  line-height: 1.35;\n}\n\n.character-modal-label {\n  display: flex;\n  min-width: 0;\n  margin: 0;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.character-modal-label--grow {\n  flex: 1;\n}\n\n.character-modal-label > span,\n.character-field-label {\n  color: var(--color-text-primary);\n  font-size: 9.5px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.character-modal-label > span em {\n  margin-left: 5px;\n  color: var(--color-text-secondary);\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.character-modal-label > small {\n  color: var(--color-text-secondary);\n  font-size: 8px;\n  line-height: 1.35;\n}\n\n.character-modal-input,\n.character-modal-textarea {\n  width: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n  color: var(--color-text-primary);\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  outline: none;\n  font: 400 11px/1.5 'Geist Sans', system-ui, sans-serif;\n  transition: border-color 0.15s ease;\n}\n\n.character-modal-input {\n  height: 32px;\n}\n\n.character-modal-input:focus,\n.character-modal-textarea:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.character-modal-input::placeholder,\n.character-modal-textarea::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.72;\n}\n\n.character-modal-textarea {\n  min-height: 82px;\n  resize: vertical;\n}\n\n.character-modal-textarea--appearance {\n  min-height: 210px;\n  flex: 1;\n}\n\n.character-modal-textarea--script {\n  min-height: 66px;\n}\n\n.character-voice-source {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.character-voice-source-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.character-voice-source-options > button {\n  display: flex;\n  min-width: 0;\n  min-height: 42px;\n  padding: 7px 8px;\n  align-items: center;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.character-voice-source-options > button:hover {\n  color: var(--color-text-primary);\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n}\n\n.character-voice-source-options > button.active {\n  color: var(--character-primary-text);\n  background: var(--character-primary-bg);\n  border-color: var(--character-primary-border);\n}\n\n.character-voice-source-options > button > span {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.character-voice-source-options strong,\n.character-voice-source-options small {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.character-voice-source-options strong {\n  color: var(--color-text-primary);\n  font-size: 9.5px;\n  font-weight: 600;\n}\n\n.character-voice-source-options small {\n  color: var(--color-text-secondary);\n  font-size: 7.5px;\n  font-weight: 500;\n}\n\n.character-voice-source-options > button.active strong {\n  color: var(--character-primary-text);\n}\n\n.character-voice-source-options > button.active small {\n  color: rgba(255, 255, 255, 0.68);\n}\n\n.character-voice-upload {\n  display: flex;\n  width: 100%;\n  min-height: 68px;\n  padding: 10px;\n  box-sizing: border-box;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-input);\n  border: 1px dashed var(--color-border-input);\n  border-radius: 4px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.character-voice-upload:hover,\n.character-voice-upload.dragging {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n}\n\n.character-voice-upload.has-file {\n  border-style: solid;\n}\n\n.character-voice-upload-icon {\n  color: var(--color-text-secondary);\n  flex: 0 0 auto;\n}\n\n.character-voice-upload-copy {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.character-voice-upload-copy strong,\n.character-voice-upload-copy small {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.character-voice-upload-copy strong {\n  color: var(--color-text-primary);\n  font-size: 9.5px;\n  font-weight: 600;\n}\n\n.character-voice-upload-copy small {\n  color: var(--color-text-secondary);\n  font-size: 8px;\n}\n\n.character-voice-upload-status {\n  flex: 0 0 auto;\n  color: var(--color-text-secondary);\n  font-size: 8px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.character-voice-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n}\n\n.character-voice-preview {\n  display: flex;\n  min-height: 58px;\n  padding: 9px 10px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n}\n\n.character-voice-preview.ready {\n  display: block;\n}\n\n.character-voice-preview-empty {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n}\n\n.character-voice-preview-empty > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.character-voice-preview-empty strong {\n  color: var(--color-text-primary);\n  font-size: 9.5px;\n  font-weight: 600;\n}\n\n.character-voice-preview-empty small {\n  overflow: hidden;\n  color: var(--color-text-secondary);\n  font-size: 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.character-voice-generate {\n  display: inline-flex;\n  min-height: 30px;\n  padding: 6px 10px;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  color: var(--character-primary-text);\n  background: var(--character-primary-bg);\n  border: 1px solid var(--character-primary-border);\n  border-radius: 4px;\n  font: 600 9px/1.2 inherit;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.character-voice-generate:hover:not(:disabled) {\n  background: var(--character-primary-bg-hover);\n}\n\n.character-voice-generate:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.character-voice-preview-heading {\n  display: flex;\n  margin-bottom: 8px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.character-voice-preview-heading > span {\n  color: var(--color-text-secondary);\n  font-size: 8px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.character-voice-preview-heading > button {\n  display: inline-flex;\n  padding: 2px 0;\n  align-items: center;\n  gap: 4px;\n  color: var(--color-text-secondary);\n  background: transparent;\n  border: 0;\n  font: 600 8px/1.2 inherit;\n  cursor: pointer;\n}\n\n.character-voice-preview-heading > button:hover:not(:disabled) {\n  color: var(--color-text-primary);\n}\n\n.character-voice-player {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n}\n\n.character-voice-player-toggle {\n  display: grid;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  place-items: center;\n  color: var(--character-primary-text);\n  background: var(--character-primary-bg);\n  border: 1px solid var(--character-primary-border);\n  border-radius: 50%;\n  cursor: pointer;\n  flex: 0 0 auto;\n}\n\n.character-voice-player-toggle:hover {\n  background: var(--character-primary-bg-hover);\n}\n\n.character-voice-player-toggle svg:not(.lucide-pause) {\n  margin-left: 1px;\n}\n\n.character-voice-player-progress {\n  height: 3px;\n  min-width: 60px;\n  margin: 0;\n  padding: 0;\n  accent-color: var(--color-text-primary);\n  cursor: pointer;\n  flex: 1;\n}\n\n.character-voice-player-time {\n  color: var(--color-text-secondary);\n  font: 500 8px/1 ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.character-modal-footer {\n  display: flex;\n  min-height: 54px;\n  padding: 9px 10px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  background: var(--color-bg-sidebar);\n  border-top: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n}\n\n.character-modal-feedback {\n  min-width: 0;\n  color: var(--color-text-secondary);\n  font-size: 8.5px;\n  line-height: 1.35;\n}\n\n.character-modal-error {\n  display: inline;\n  margin: 0;\n  padding: 0;\n  color: var(--color-status-error-text, #dc2626);\n  background: transparent;\n  font-size: 9px;\n  font-weight: 500;\n}\n\n.character-modal-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.character-modal-cancel,\n.character-modal-submit {\n  display: inline-flex;\n  min-height: 32px;\n  padding: 7px 12px;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  border-radius: 4px;\n  font: 500 10px/1.2 inherit;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.character-modal-cancel {\n  color: var(--color-text-primary);\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n}\n\n.character-modal-cancel:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.character-modal-submit {\n  color: var(--character-primary-text);\n  background: var(--character-primary-bg);\n  border: 1px solid var(--character-primary-border);\n}\n\n.character-modal-submit:hover:not(:disabled) {\n  background: var(--character-primary-bg-hover);\n}\n\n.character-modal-cancel:disabled,\n.character-modal-submit:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.character-modal-submit kbd {\n  margin-left: 2px;\n  padding: 2px 4px;\n  color: rgba(255, 255, 255, 0.72);\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 3px;\n  font: 500 8px/1 ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.character-modal-close:focus-visible,\n.character-voice-source-options > button:focus-visible,\n.character-voice-upload:focus-visible,\n.character-voice-generate:focus-visible,\n.character-voice-player-toggle:focus-visible,\n.character-modal-cancel:focus-visible,\n.character-modal-submit:focus-visible {\n  outline: 2px solid var(--color-text-secondary);\n  outline-offset: 1px;\n}\n\n.character-spin {\n  animation: characterSpin 0.85s linear infinite;\n}\n\n@keyframes characterSpin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 800px) {\n  .character-modal-overlay {\n    align-items: flex-end;\n    padding: 12px;\n  }\n\n  .character-modal {\n    max-height: calc(100vh - 24px);\n  }\n\n  .character-modal-body {\n    display: block;\n  }\n\n  .character-form-panel {\n    padding: 16px;\n  }\n\n  .character-form-panel--voice {\n    border-top: 1px solid var(--color-border-input);\n    border-left: 0;\n  }\n\n  .character-modal-textarea--appearance {\n    min-height: 112px;\n  }\n}\n\n@media (max-width: 540px) {\n  .character-modal-overlay {\n    padding: 0;\n  }\n\n  .character-modal {\n    width: 100%;\n    height: 100%;\n    max-height: none;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .character-modal-heading-copy p,\n  .character-modal-feedback,\n  .character-modal-submit kbd {\n    display: none;\n  }\n\n  .character-voice-source-options {\n    grid-template-columns: 1fr;\n  }\n\n  .character-modal-footer {\n    justify-content: flex-end;\n  }\n\n  .character-modal-submit {\n    flex: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .character-spin {\n    animation-duration: 1.5s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
